import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getEBIGene2PhenotypeData } from "../../../../state/selectors/EBIGene2Phenotype.selectors";
import { EBIGene2PhenotypeType } from "../../../componentTypes/EBIGene2PhenotypeType";

const GeneEBIGene2PhenotypeCard = ({ card, ebiGene2PhenotypeData }) => {
  const isDisabled = !Object.keys(ebiGene2PhenotypeData || {}).length;
  const { items } = ebiGene2PhenotypeData || {};
  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      {items && items.length > 1 && (
        <>
          {items[0]?.disease && (
            <div data-testid="ebi-gene-2-phenotype-disease">
              Disease: <span className="tw-font-bold">{items[0]?.disease}</span>
            </div>
          )}
          {items[0]?.inheritance && (
            <div data-testid="ebi-gene-2-phenotype-inheritance">
              Inheritance:{" "}
              <span className="tw-font-bold">{items[0]?.inheritance}</span>
            </div>
          )}
        </>
      )}
    </CardWrapper>
  );
};

GeneEBIGene2PhenotypeCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  ebiGene2PhenotypeData: EBIGene2PhenotypeType,
};

GeneEBIGene2PhenotypeCard.defaultProps = {
  ebiGene2PhenotypeData: {},
};

const mapStateToProps = (state) => ({
  ebiGene2PhenotypeData: getEBIGene2PhenotypeData(state),
});

export default connect(mapStateToProps, {})(GeneEBIGene2PhenotypeCard);
